import { useMe } from '@capsicum/socios-core';

export const useLatestAcceptedAgreement = () => {
	const { me } = useMe();

	const latestAcceptedAgreementLink = me.latestAcceptedAgreementVersion;

	return {
		latestAcceptedAgreementLink
	};
};
